import React, { useState, useMemo } from "react";
import DataTable from "components/DataTable";
import PageWrapper from "components/PageWrapper";
import { useTableData } from "../../hooks/useTableData";
import { walletSettlementReportsConfig } from "config/tableConfigs";
import { useSession } from "hooks/useSession";

const WalletSettlementReportsPage = () => {
  const { userid, role } = useSession();
  const [loading] = useState(false);

  const getLast7Days = () => {
    const today = new Date();
    const last7 = new Date();
    last7.setDate(today.getDate() - 1)  ;
  
    return {
      start: last7.toISOString().split("T")[0],
      end: today.toISOString().split("T")[0],
    };
  };
  
 const getTodayRange = () => {
  const today = new Date();
  const todayStr = today.toISOString().split("T")[0];
  return {
    start: todayStr,
    end: todayStr,
  };
};

const { start, end } = getTodayRange();

  const [apiUrl, setApiUrl] = useState(
    `https://api.mokshiq.in/get_payout_report?user=${userid}&filter_date=${start}&end_date=${end}`
  );

  const tableData = useTableData(apiUrl, 0, walletSettlementReportsConfig);

  const handleDateFilter = (s, e) => {
    setApiUrl(
      `https://api.mokshiq.in/get_payout_report?user=${userid}&filter_date=${s}&end_date=${e}`
    );
  };

  // 🔥 ROLE → COLUMN BINDING (SAME AS DMT)
  const filteredConfig = useMemo(() => {
    const base = { ...walletSettlementReportsConfig };

   const roleMap = {
  Retailer: [
    "id",
    "ref_no",
    "ack_no",
    "product",
    "account_number",
    "holder_name",
    "number",
    "amount",
    "created_at",
    "status",
    "Opening Balance",
    "Commission",
    "TDS",
    "Charge",
    "GST",
    "Closing Balance",
    "bank_rrn",
  ],

  Distributer: [
    "id",
    "ref_no",
    "ack_no",
    "product",
    "account_number",
    "holder_name",
    "number",
    "amount",
    "created_at",
    "status",
    "openingBalanceDistributor",
    "commission",
    "tds",
    "charge",
    "gst",
    "closingBalanceDistributor",
    "bank_rrn",
  ],

  "Super Distributer": [
    "id",
    "ref_no",
    "ack_no",
    "product",
    "account_number",
    "holder_name",
    "number",
    "amount",
    "created_at",
    "status",
    "openingBalanceSuperDistributor",
    "commission",
    "tds",
    "charge",
    "gst",
    "closingBalanceSuperDistributor",
    "bank_rrn",
  ],
  "White label": [
    "id",
    "bcName",          // Agent Name from your JSON
    "ref_no",
    "ack_no",
    "account_number",  // From your JSON
    "holder_name",     // From your JSON
    "amount",
    "status",
    
    // White Label's Own Financials
    "Opening Balance", 
    "Commission", 
    "TDS", 
    "Charge", 
    "GST", 
    "Closing Balance",

    // Agent's (BC) Financials
    "Opening Balance BC", 
    "BC Commission", 
    "BC TDS", 
    "BC Charge", 
    "Closing Balance BC",

    "bank_rrn",
    "created_at"
  ],

  Admin: [
    "id",
    "ref_no",
    "ack_no",
    "product",
    "number",
    "amount",
    "created_at",
    "status",
    "bcName",
    "openingBalanceAdmin",
    "commissionAdmin",
    "tdsAdmin",
    "chargeAdmin",
    "gstAdmin",
    "closingBalanceAdmin",
    "walletTxn",
    "txnFlow",
    "bank_rrn",
  ],

  "Main Admin": walletSettlementReportsConfig.columns.map((c) => c.key),
};


    const allowedKeys = roleMap[role] || [];
    base.columns = base.columns.filter((c) =>
      allowedKeys.includes(c.key)
    );

    return base;
  }, [role]);

  return (
    <div>
      {loading && (
        <div className="page-loader-overlay d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" />
        </div>
      )}

      <PageWrapper
        config={walletSettlementReportsConfig}
        onDateFilter={handleDateFilter}
      >
        <DataTable
          config={filteredConfig}
          tableData={tableData}
          onView={() => {}}
          onEdit={() => {}}
          onDelete={() => {}}
          onExport={() => {}}
          onDeleteSelected={() => {}}
        />
      </PageWrapper>
    </div>
  );
};

export default WalletSettlementReportsPage;
